import { StrategyBuilderFunction, EMPTY_STRATEGY } from './types';
import { addLongCall, addLongPut } from './addOption';
import {
  getDefaultExpiration,
  findClosestStrikePrice,
  getStrikesAtExpiration,
  expirationToDate,
  getPremium,
  getStrategyLegStrikeDirection,
  getStrikeDistance,
} from './utils';

export const strangle: StrategyBuilderFunction = ({
  chain,
  spot,
  expirationDate,
  expirationKey,
  strikeDirection,
  contractMultiplier = 1,
}) => {
  const strikesAtExpiration = expirationKey
    ? getStrikesAtExpiration(chain, expirationKey)
    : getDefaultExpiration(chain);

  if (
    !strikesAtExpiration ||
    !strikesAtExpiration.e ||
    !strikesAtExpiration.ey ||
    !strikesAtExpiration.em ||
    !strikesAtExpiration.ed
  ) {
    return EMPTY_STRATEGY;
  }

  const expirationDateForOptions =
    expirationDate ||
    expirationToDate(strikesAtExpiration.ey, strikesAtExpiration.em, strikesAtExpiration.ed);
  const expirationKeyForOptions = expirationKey || strikesAtExpiration.e;

  // Setting strike prices for the strangle strategy
  const putStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: -2 }),
  );
  const callStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: 2 }),
  );

  return {
    optionPositions: [
      addLongCall({
        strike: callStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[callStrike]?.c?.a || 0,
          bid: strikesAtExpiration?.c?.[callStrike]?.c?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'long'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
      addLongPut({
        strike: putStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[putStrike]?.p?.a || 0,
          bid: strikesAtExpiration?.c?.[putStrike]?.p?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'long'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
    ],
    stockPositions: [],
  };
};
